export default __webpack_public_path__ + "static/media/video16.822402eb.webp";